import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

interface ConsumerTokenRequest {
	workspaceId?: string
	workspaceName?: string
	metadata?: {
		username?: string
		email?: string
	}
}

interface ConsumerTokenResponse {
	token: string
	expires_at?: string
}

/**
 * Hook to get a consumer token for Kolla Connect authentication
 */
export const useConsumerToken = () => {
	const authFetch = useHoneyGridApiFetch()

	return useMutation<ConsumerTokenResponse, Error, ConsumerTokenRequest>({
		mutationFn: async (request: ConsumerTokenRequest): Promise<ConsumerTokenResponse> => {
			if (!request.workspaceId) {
				toast.error('Workspace ID is required')
				return { token: '' }
			}
			return await authFetch('kolla/consumer-token', {
				method: 'POST',
				body: request,
			})
		},
	})
}
